import { render, staticRenderFns } from "./InfoPlan.vue?vue&type=template&id=407c3c0b&scoped=true&"
import script from "./InfoPlan.vue?vue&type=script&lang=js&"
export * from "./InfoPlan.vue?vue&type=script&lang=js&"
import style0 from "./InfoPlan.vue?vue&type=style&index=0&id=407c3c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c3c0b",
  null
  
)

export default component.exports